import { render, staticRenderFns } from "./SEOTextWidget.vue?vue&type=template&id=0aac4cf0&"
import script from "./SEOTextWidget.vue?vue&type=script&lang=js&"
export * from "./SEOTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-stylebreaker-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aac4cf0')) {
      api.createRecord('0aac4cf0', component.options)
    } else {
      api.reload('0aac4cf0', component.options)
    }
    module.hot.accept("./SEOTextWidget.vue?vue&type=template&id=0aac4cf0&", function () {
      api.rerender('0aac4cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/home/SEOTextWidget.vue"
export default component.exports